import colors from '@/design/colors';
import { View, Text } from '@react-pdf/renderer';
import React from 'react';
import { ReactPDFStyle } from '../DocumentPanel';

interface Props {
  legend: string;
  style?: ReactPDFStyle;
}

const Signature: React.FC<Props> = ({ legend, style = {} }) => {
  return (
    <View
      style={[
        {
          flexDirection: 'column',
          marginVertical: 8,
          alignItems: 'center',
          width: '40%',
        },
        style,
      ]}
    >
      <View
        style={{
          width: '100%',
          borderBottomWidth: 1,
          borderBottomColor: colors.blackAlpha200,
          marginBottom: 12,
        }}
      />

      <Text style={{ alignSelf: 'center', fontSize: 9 }}>{legend}</Text>
    </View>
  );
};

export default Signature;
